import { Parser } from 'acorn'
import codeFrame from 'code-frame'

import { createMustachePlugin } from './acorn-plugin'

import type { Mustache, Options } from 'acorn'

export { parse as json5Parse } from './json5'
export type ParseOptions = Options
export const parse = (input: string, options?: ParseOptions): Mustache => {
  try {
    const ast = Parser.extend(createMustachePlugin()).parse(input.trim(), {
      ...options,
      ecmaVersion: 'latest',
      locations: true,
      ranges: true
    }) as Mustache
    return ast
  } catch (error) {
    if (error instanceof SyntaxError) {
      const frame = codeFrame(input, error.loc.line, error.loc.column)
      error.message = `${error.message}\n\n${frame}\n`
      error.columnNumber = error.loc.column
      error.filename = options?.sourceFile
      error.lineNumber = error.loc.line
      throw error
    }
    throw error
  }
}
export { type AnyNode, type Node } from 'acorn'
